module.exports = __webpack_public_path__ + "static/media/whatsapp-brands.28b77b20.svg";